export class AppConsts {
    public static readonly LocationHeaderKey: string = "RKG-LocationId";

    //Role Names
    public static readonly Admin: string = "Admin";
    public static readonly SiteAdmin: string = "SiteAdmin";
    public static readonly ManageWhiteList: string = "ManageWhiteList";
    public static readonly Employee: string = "Employee";
    public static readonly Manager: string = "Manager";
    public static readonly Enforcement: string = "Enforcement";
    public static readonly Reports: string = "Reports";

    public static readonly MaxInt = 2147483647;
}